export const RADIO = 'RADIO';
export const CHECKBOX = 'CHECKBOX';
export const CONTEXTUALIZED_SELECTS = 'CONTEXTUALIZED_SELECTS';
export const AUTOCOMPLETE = 'AUTOCOMPLETE';
export const EXCLUSIVE = 'EXCLUSIVE';
export const MULTI_SELECT = 'MULTI_SELECT';
export const EMPTY = 'EMPTY';
export const DATEPICKER = 'DATEPICKER';
